var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Button } from "syf-component-library/ui/atoms";
export var CancelButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 92px;\n"], ["\n  min-width: 92px;\n"])));
export var FooterWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var templateObject_1, templateObject_2;
